module.exports = __webpack_public_path__ + "static/media/Test9.96793fb4.bmp";